export const APP_ROUTES = {
  home: '/',
  chat: 'chat',
  mode: ':mode',
  loader: 'loader',
  error: 'error'
} as const;
